import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';

import {HttpClient} from '@angular/common/http';
import {BaseRestService} from '../../common/BaseRestService';
import {AgeGroupsData} from '../../../types/nso-data-portal/census-data';


@Injectable()
export class AdministrationInformationRestService extends BaseRestService {

  constructor(private http: HttpClient) {
    super('administration/age-groups');
  }

  getAgeGroups(): Observable<AgeGroupsData[]> {
    return this.http.get<AgeGroupsData[]>(this.getEndpoint([]));
  }

  createAgeGroup(ageGroup) {
    return this.http.post<AgeGroupsData>(this.getEndpoint([]), ageGroup);
  }

  updateAgeGroup(ageGroup) {
    return this.http.put<AgeGroupsData>(this.getEndpoint([String(ageGroup.id)]), ageGroup);
  }

  getAgeGroupsTypes() {
    return this.http.get<string[]>(this.getEndpoint(['types']));
  }

  deleteAgeGroup(ageGroup) {
    return this.http.delete(this.getEndpoint([ageGroup.id]));
  }

  getAgeGroupStatus(ageGroup): Observable<boolean> {
    return this.http.get<boolean>(this.getEndpoint([ageGroup.id, 'usage-status']));
  }

}
